<template>
  <v-container class="mt-16">
    <div class="mb-2 d-flex">
      <p class="subtitle-2">Actions:</p>

      <print-batch-item-modal />

      <!-- all items list modal -->
      <v-btn @click="enable_all_item_modal = true" small text
        ><v-icon class="mr-2">mdi-box</v-icon>All Items List</v-btn
      >
      <item-types-modal class="mr-2" v-if="user.access_level >= 6" />

      <v-btn
        color="yellow"
        class="mr-2"
        @click="print_inventory"
        v-if="user.access_level != 5"
        >Print Inventory</v-btn
      >
      <item-transfer-modal v-if="user.access_level != 5" />
    </div>
    <v-divider></v-divider>
    <div v-if="ready">
      <!-- ITEMS TABLE  -->
      <v-card class="pl-5 pr-5" flat>
        <v-card-title class="d-flex">
          <h2 class="text-uppercase">Products and Services</h2>
          <v-spacer></v-spacer>
          <AddItemModal v-if="user.access_level >= 6" />
          <v-btn
            color=""
            class=""
            icon
            x-large
            @click="refresh"
            :loading="loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="item_search"
            prepend-icon="mdi-magnify"
            label="Search Item"
          ></v-text-field>
          <v-data-table
            :items="items"
            :headers="item_headers"
            :search="item_search"
          >
            <template v-slot:item.item_name="{ item }">
              <span
                :class="
                  item.is_vat
                    ? 'green--text font-weight-bold'
                    : 'orange--text font-weight-bold'
                "
                >{{ item.item_name }}</span
              >
            </template>
            <template v-slot:item.warranty="{ item }">
              <span v-if="item.warranty">{{
                item.warranty.warranty_count +
                " " +
                item.warranty.warranty_duration
              }}</span>
            </template>

            <template v-slot:item.action="{ item }">
              <div class="d-flex" v-if="user.access_level >= 6">
                <v-btn icon color="primary" @click="open_item_profile(item)"
                  ><v-icon>mdi-list-box</v-icon></v-btn
                >
                <v-btn @click="edit_item(item)" icon color="yellow"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn icon color="green" @click="openTransactionHistory(item)"
                  ><v-icon>mdi-clipboard-text-clock-outline</v-icon></v-btn
                >
                <!-- <edit-resellers-item-modal :item="item" /> -->
                <v-btn
                  icon
                  color="red"
                  @click="confirm_delete(item)"
                  :loading="loading"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table></v-card-text
        >
      </v-card>
      <v-divider></v-divider>
    </div>
    <v-row v-else class="d-flex justify-center">
      <h2 class="text-center mt-10 mb-10">Data Table is loading...</h2>
    </v-row>
    <!-- Lazy loaded components -->
    <item-profile-modal
      :item="selected_item"
      v-if="item_profile_modal"
      @close="item_profile_modal = false"
    />
    <edit-item-modal
      :item="selected_item"
      v-if="edit_item_modal"
      @close="edit_item_modal = false"
    />
    <all-item-modal
      v-if="enable_all_item_modal"
      @close="enable_all_item_modal = false"
    />
    <!-- lazy loaded components -->
    <item-transaction-history-modal
      :item="selected_item"
      v-if="transactionHistoryDialog"
      @close="transactionHistoryDialog = false"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddItemModal from "../components/Item/addItemModal.vue";

import ItemTransferModal from "../components/Item/itemTransferModal.vue";
import ItemTypesModal from "../components/Item/itemTypesModal.vue";
import PrintBatchItemModal from "../components/Item/printBatchItemModal.vue";

export default {
  data() {
    return {
      enable_all_item_modal: false,
      selected_item: [],
      item_profile_modal: false,
      edit_item_modal: false,
      item_search: "",
      service_search: "",
      loading: false,
      ready: false,

      item_headers: [
        { text: "Actions", value: "action" },
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Item Name",
          value: "item_name",
          width: "250",
        },
        { text: "Item Description", value: "item_description", width: "280" },
        {
          text: "Import Batch Description",
          value: "import_batch.batch_description",
        },
        {
          text: "Supplier",
          value: "supplier.supplier_name",
        },
        {
          text: "Unit Price",
          value: "unit_price",
        },
        {
          text: "Selling Price",
          value: "selling_price",
        },

        {
          text: "Item Type",
          value: "item_type.item_type",
        },

        {
          text: "Available Stocks",
          value: "quantity",
        },
        {
          text: "Initial Import",
          value: "initial_import",
        },
        {
          text: "Account Title",
          value: "chart_of_account.account_title",
        },
        {
          text: "Unit",
          value: "unit",
        },
        {
          text: "Warranty",
          value: "warranty",
        },
      ],
      transactionHistoryDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      items: "item/items",
      default_server_url: "auth/default_server_url",
      item_types: "item_type/item_types",
      branches: "branch/branches",
    }),
  },
  methods: {
    openTransactionHistory(item) {
      this.transactionHistoryDialog = true;
      this.selected_item = item;
    },
    open_item_profile(item) {
      this.selected_item = item;
      this.item_profile_modal = true;
    },
    edit_item(item) {
      this.selected_item = item;
      this.edit_item_modal = true;
    },
    print_inventory() {
      let display_price = window.confirm("Display price?");
      display_price = display_price ? 1 : 0;
      let url =
        this.default_server_url +
        "/print_inventory/" +
        this.user.branch_id +
        "/" +
        display_price;
      window.open(url);
    },
    del(service) {
      let x = window.confirm("Are you sure you want to delete this service?");
      this.loading = true;
      if (x) {
        this.delete_service(service.id).then(() => {
          alert("Successfully deleted a service");
        });
      }
      this.loading = false;
    },
    confirm_delete(item) {
      let x = window.confirm("Are you sure you want to delete this item?");
      if (x) {
        this.loading = true;
        this.delete_item(item.id).then(() => {
          alert("Successfully deleted an item");
          this.loading = false;
        });
      }
    },
    ...mapActions({
      get_items: "item/get_items",
      get_branches: "branch/get_branches",
      delete_item: "item/delete_item",
      delete_service: "service/delete_service",
      get_item_types: "item_type/get_item_types",
    }),
    refresh() {
      this.loading = true;

      this.get_items().then(() => {
        this.loading = false;
      });
    },
    edit_service(item) {
      console.log(item);
    },
  },
  async created() {
    if (this.branches.length <= 0) await this.get_branches();
    if (this.items.length <= 0) await this.get_items("not_all");
    if (this.item_types.length <= 0) await this.get_item_types();
    this.ready = true;
  },
  components: {
    AddItemModal,
    EditItemModal: () => import("../components/Item/editItemModal.vue"),
    PrintBatchItemModal,
    ItemTypesModal,
    AllItemModal: () => import("../components/Item/allItemModal.vue"),
    ItemProfileModal: () => import("../components/Item/itemProfileModal.vue"),
    ItemTransactionHistoryModal: () =>
      import("../components/Item/itemTransactionHistoryModal.vue"),
    ItemTransferModal,
  },
};
</script>

<style
  lang="scss,
 ,
    PrintSalesSummaryModal   UpdatedItemsModal
    PrintSalesSummaryModal"
  scoped
></style>
